/**
 * Operation names for client queries that are declared as inline `gql` templates.
 *
 * Codegen only reads `packages/@paintscout/api/src/**\/*.graphql`, so inline queries get no
 * generated `*Document` and the only way to name them in `refetchQueries` /
 * `delayedRefetchQueries` is a raw string. Apollo Client 2.x matches those strings against
 * operation names by exact equality and does **not** warn when a name matches nothing, so a
 * rename on one side silently turns the refetch into a permanent no-op — which is exactly how
 * `'getLastActivity'` rotted after QuoteSidebar's query became `sidebarInfo` (#22137).
 *
 * Importing the constant at both the query definition and the refetch site keeps the two ends
 * moving together. Prefer `getOperationName(<X>Document)` whenever a generated document exists.
 */

/** QuoteSidebar's "last activity" query (`apps/app/src/components/common/QuoteSidebar/QuoteSidebar.tsx`). */
export const QUOTE_SIDEBAR_INFO_QUERY_NAME = 'sidebarInfo'
